import React from 'react'
import './OneOrder.css'
import prettyDateTime from '../../../function/prettyDateTime'
import dayjs from 'dayjs'
const OneOrder = ({oneOrder, listOfDrivers}) => {
   
    const status = parseInt( oneOrder.status )
    const driverId = parseInt( oneOrder.driver )
    const imgOfCar = `https://abcnet.cz/taxi/avatarOfDrivers/${driverId}.jpeg`;
    let driverInfo = listOfDrivers.filter( one => {
        return parseInt(one.id) === driverId
    })
    // Zobrazí poslední tři číslice
    const idString = oneOrder.id.toString();
    // Získání posledních tří číslic
    const lastThreeDigits = idString.slice(-3);

    let color = ""
    // Zobrazí jen aktivní objednávky
  
    if(status < 5 || status === 7){
        if(status === 1 && oneOrder.bookTime === null){
            color = "#d73d6e"
        } else if( status === 2){
            color = "#05ffa4"
        } else if ( status === 3){
            color = "orange"
        } else if(oneOrder.bookTime !== null){
            color = "grey"
        }
      return (
        <div className='oneOrderContainer' style={{background: color}}>
            <h2>č.:{lastThreeDigits}</h2>
            { driverId > 0 && driverInfo && <div className="infoAboutDriver">
                                    <img src={imgOfCar} alt="" /> 
                                    <h3>{driverInfo  && driverInfo[0]?.nick}</h3>
                             </div>
            }
            
            {oneOrder.bookTime === null && <h2>{ prettyDateTime ( oneOrder.date )}</h2> }
     
            {oneOrder.bookTime !== null && <p>Objendávka na čas:</p> }
            {oneOrder.bookTime !== null && <h2>{ prettyDateTime ( oneOrder.bookTime )}</h2> }
            <p>Start: {oneOrder.start}</p>
            <p>Cíl: {oneOrder.destination}</p>
            <h3>Tel: {oneOrder.tel}</h3>
            <p>Cena: {oneOrder.price} Kč / {(parseInt(oneOrder.tripDistance) / 1000 ).toFixed(1) } Km</p>
            { oneOrder.destinationTime && <p>Plánovaný čas příjezdu: { dayjs(oneOrder.destinationTime).format('HH:mm - DD.MM. ') }</p> }
        </div>
      )
    }

}

export default OneOrder
